import React, {Component} from 'react';
import {
  GoogleReCaptchaProvider, GoogleReCaptcha
} from 'react-google-recaptcha-v3';

import icoFacebook from './assets/webyoo/media/ico-facebook.jpg';
import icoTwitter from './assets/webyoo/media/ico-twitter.jpg';
import icoWhatsapp from './assets/webyoo/media/ico-whatsapp.jpg';
import icoInstagram from './assets/webyoo/media/ico-instagram.jpg';

import APIClient from './Api';


const api = new APIClient();


const SHARE_URL = 'https://laffairedusiecle.net/temoin-du-climat/';

const SHARE_DEFAULT_TEXT = `Canicules, inondations, disparition d’espèces, érosion des côtes…
Les changements climatiques se font déjà sentir en France !
L'État doit prendre la mesure de l'urgence climatique.
Je suis #TémoinDuClimat avec #LAffaireDuSiecle, et vous ?
${SHARE_URL}`;




const NETWORKS = {
  facebook: {
    id: 1,
    // TODO
    // - quelle url partager
    // - confirmer le titre
    // - confirmer le résumer
    url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(SHARE_URL)}`

  },
  twitter: {
    id: 2,
    // TODO
    // - confirmer le texte
    url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_DEFAULT_TEXT)}`
  },
  instagram: {
    id: 3,
    // TODO
    // - quelle url partager
    url: 'https://www.instagram.com/affairedusiecle/'

  },
  whatsapp: {
    id: 4,
    // TODO
    // - confirmer le texte
    url: `whatsapp://send?text=${encodeURIComponent(SHARE_DEFAULT_TEXT)}`
  }
};


class Share extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // track clicks to be challenged by reCaptcha
      // and sent to API
      challenges: {}
    };
  }
  
  clickHandler = (networkID) => (event) => {
    // Don't prevent default click to continue
    // Click counting is async and must not interrupt
    // user in any case.
    // Just add a new challenge and continue
    // The new challenge must have a unique key.
    // Date.now have millisecond precision and should be fine.
    this.setState((state) => ({
      challenges: {
        ...state.challenges,
        [Date.now()]: networkID
      }
    }));
  }
  
  verifyCaptchaHandler = (key) => (value) => {
    // Execute the challenge
    const networkID = this.state.challenges[key];
    const payload = {
      social_network: networkID,
      captcha: value
    }
    console.log(payload);
    api.createSocialShare(payload);

    this.setState((state) => {
      // remove the executed challenge
      const challenges = {...state.challenges};
      delete challenges[key];
      return {
        challenges
      };
    });
  }


  render() {
    const { facebook, twitter, whatsapp, instagram } = NETWORKS;
    const { challenges } = this.state;
    return (
      <div class="gp-partage-reseau">
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SOCIAL_SITE_KEY}
        >
          {Object.entries(challenges).map(([key, networkID]) => (
            <GoogleReCaptcha
              key={key}
              onVerify={this.verifyCaptchaHandler(key)}
            />
          ))}
          <div class="gp-reseau">
            <a
              onClick={this.clickHandler(facebook.id)}
              id="fb-link"
              target="_blank"
              className="gb_ico"
              href={facebook.url}
              rel="noopener noreferrer"
            >
              <img src={icoFacebook} alt="" />
            </a>
          </div>
          <div class="gp-reseau">
            <a
              onClick={this.clickHandler(twitter.id)}
              target="_blank"
              className="gb_ico"
              href={twitter.url}
              rel="noopener noreferrer"
            >
              <img src={icoTwitter} alt="" />
            </a>
          </div>
          <div class="gp-reseau">
            <a
              onClick={this.clickHandler(whatsapp.id)}
              target="_blank"
              className="gb_ico"
              href={whatsapp.url}
              rel="noopener noreferrer"
            >
              <img src={icoWhatsapp} alt="" />
            </a>
          </div>
          <div class="gp-reseau">
            <a
              onClick={this.clickHandler(instagram.id)}
              target="_blank"
              className="gb_ico"
              href={instagram.url}
              rel="noopener noreferrer"
            >
              <img src={icoInstagram} alt="" />
            </a>
          </div>
        </GoogleReCaptchaProvider>
      </div>
    );
  }
}

export default Share;
